import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { api } from "../api";

export function QrPage() {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [exp, setExp] = useState<number | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [now, setNow] = useState<number>(Math.floor(Date.now() / 1000));

  const refresh = async () => {
    setErr(null);
    try {
      const r = await api.get<{ token: string; expiresAt: number }>(
        "/member/me/qr-token",
      );
      const url = await QRCode.toDataURL(r.token, { width: 320, margin: 1 });
      setDataUrl(url);
      setExp(r.expiresAt);
    } catch (e) {
      setErr((e as Error).message);
    }
  };

  useEffect(() => {
    refresh();
    const t = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => clearInterval(t);
  }, []);

  const remain = exp != null ? Math.max(0, exp - now) : null;
  useEffect(() => {
    if (remain === 0) refresh();
  }, [remain]);

  return (
    <div className="card p-6 max-w-sm mx-auto text-center">
      <h2 className="font-bold text-tora">受付用 QR コード</h2>
      <p className="text-xs text-tora-ink/60 mt-1">
        スタッフに画面を提示してください。署名・有効期限付きです。
      </p>
      {err && <p className="text-sm text-red-600 mt-3">{err}</p>}
      {dataUrl && (
        <img src={dataUrl} alt="QR" className="mx-auto mt-4" />
      )}
      {remain != null && (
        <p className="mt-3 text-xs text-tora-ink/60">
          残り {remain} 秒で更新されます
        </p>
      )}
      <button onClick={refresh} className="btn-outline mt-3">
        手動更新
      </button>
    </div>
  );
}
